module.exports = __webpack_public_path__ + "static/TitleSplash-828dc501130718e2efc625c3edf902aa.png";